import * as TYPES from './mutationTypes'

export default {
  //用户列表
  [TYPES.GET_USER_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      user_system_list: payload.result.items,
      user_system_paging: { limit, offset, total }
    })
  },
  [TYPES.GET_ROLE_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      role_list: payload.result.items,
      role_paging: { limit, offset, total }
    })
  }
}
